import { compose } from 'redux';
import { injectIntl } from 'react-intl';

import withUserInfo from '../../containers/apollo/withUserInfo';
import withLocaleRedirect from '../../containers/withLocaleRedirect';
import withWorkIdFromRoute from '../../containers/withWorkIdFromRoute';
import withWork from '../../containers/apollo/withWork';
import { with404ErrorWhen } from '../../containers/withFatalErrorWhen';

import WorkModalWithMetaData from '../../components/WorkModalWithMetaData';

const ComposedWorkRoute = compose(
  injectIntl,
  withUserInfo,
  withLocaleRedirect,
  withWorkIdFromRoute,
  withWork,
  with404ErrorWhen(({ work, loading }) => !loading && !work)
)(WorkModalWithMetaData);

ComposedWorkRoute.displayName = WorkModalWithMetaData.displayName;
ComposedWorkRoute.fragment = WorkModalWithMetaData.fragment;

export default ComposedWorkRoute;
